var exports = {
  "qS": "MentionBadge.module__badge___V3Zrek",
  "ZN": "MentionBadge.module__badgeSmall___V3Zrek",
  "N1": "MentionBadge.module__badgeMedium___V3Zrek",
  "x5": "MentionBadge.module__animatedWrapper___V3Zrek",
};

module.exports = exports;
